<template>
    <div class="fhv-centent" v-loading="loading">
        <h4 class="title-topic">QoS Settings</h4>
        <el-form label-width="180px" label-position="left"  class="fhv-form"
        :disabled="$G_DEVICE_CFG.isReadOnly">
            <el-form-item label="Enable QoS :" > 
                <el-switch v-model="qosEnable" @change="setQosEnable"></el-switch>
            </el-form-item>
        </el-form>
        <div v-if="qosEnable">
        <hr>
        <h4>Uplink</h4>
        <el-form label-width="180px" label-position="left"  class="fhv-form" size="mini"
        :disabled="$G_DEVICE_CFG.isReadOnly">
            <el-form-item label="Uplink Limit Mode :" >
                <el-select 
                v-model="up.mode" 
                placeholder="Please select Uplink Limit Mode" 
                @change="selectQosMode('up')"
                style="width: 100%">
                    <el-option label="Close" value="0"></el-option>
                    <el-option label="User-side interface speed limit" value="1"></el-option>
                    <el-option label="User-side IP speed limit" value="3"></el-option>
                    <el-option label="User-side MAC speed limit" value="4"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <!-- interface -->
        <el-table :data="up.iface" border class="fhv-table" size="mini" v-if="up.mode === '1'">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column label="LAN/SSID" prop="iface"></el-table-column>
            <el-table-column label="Speed Limit ( Unit, 512Kbps )" prop="rate"></el-table-column>
            <el-table-column label="Action" width="100">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="danger"
                    @click="delData(scope.$index, 'up')"
                    >Delete</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- IP -->
        <el-table :data="up.ip" border class="fhv-table" size="mini" v-if="up.mode === '3'">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column label="IP" :formatter="ipFormatter"></el-table-column>
            <el-table-column label="Speed Limit ( Unit, 512Kbps )" prop="rate"></el-table-column>
            <el-table-column label="Action" width="100">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="danger"
                    @click="delData(scope.$index, 'up')"
                    >Delete</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- MAC -->
        <el-table :data="up.mac" border class="fhv-table" size="mini" v-if="up.mode === '4'">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column label="MAC" prop="mac"></el-table-column>
            <el-table-column label="Speed Limit ( Unit, 512Kbps )" prop="rate"></el-table-column>
            <el-table-column label="Action" width="100">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="danger"
                    @click="delData(scope.$index, 'up')"
                    >Delete</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="fh-btn-contain">
            <el-button type="primary" size="mini" :disabled="$G_DEVICE_CFG.isReadOnly || up.mode === '0'" @click="showAddQos('up')">Add</el-button>
            <el-button type="primary" size="mini" @click="getData">Refresh</el-button>
        </div>
        <hr>
        <h4>Downlink</h4>
        <el-form label-width="180px" label-position="left"  class="fhv-form" size="mini"
        :disabled="$G_DEVICE_CFG.isReadOnly">
            <el-form-item label="Downlink Limit Mode :" >
                <el-select 
                v-model="down.mode" 
                placeholder="Please select Downlink Limit Mode" 
                @change="selectQosMode('down')"
                style="width: 100%">
                    <el-option label="Close" value="0"></el-option>
                    <el-option label="User-side interface speed limit" value="1"></el-option>
                    <el-option label="User-side IP speed limit" value="3"></el-option>
                     <el-option label="User-side MAC speed limit" value="4"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <!-- interface -->
        <el-table :data="down.iface" border class="fhv-table" size="mini" v-if="down.mode === '1'">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column label="LAN/SSID" prop="iface"></el-table-column>
            <el-table-column label="Speed Limit ( Unit, 512Kbps )" prop="rate"></el-table-column>
            <el-table-column label="Action" width="100">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="danger"
                    @click="delData(scope.$index, 'down')"
                    >Delete</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- IP -->
        <el-table :data="down.ip" border class="fhv-table" size="mini" v-if="down.mode === '3'">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column label="IP" :formatter="ipFormatter"></el-table-column>
            <el-table-column label="Speed Limit ( Unit, 512Kbps )" prop="rate"></el-table-column>
            <el-table-column label="Action" width="100">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="danger"
                    @click="delData(scope.$index, 'down')"
                    >Delete</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- MAC -->
        <el-table :data="down.mac" border class="fhv-table" size="mini" v-if="down.mode === '4'">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column label="MACAddress" prop="mac"></el-table-column>
            <el-table-column label="Speed Limit ( Unit, 512Kbps )" prop="rate"></el-table-column>
            <el-table-column label="Action" width="100">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="danger"
                    @click="delData(scope.$index, 'down')"
                    >Delete</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="fh-btn-contain">
            <el-button type="primary" size="mini" 
            :disabled="$G_DEVICE_CFG.isReadOnly || down.mode === '0'" 
            @click="showAddQos('down')">Add</el-button>
            <el-button type="primary" size="mini" @click="getData">Refresh</el-button>
        </div>
        </div>
        <el-dialog title="Add QoS Rules" :visible.sync="dialogFormVisible" >
            <el-form 
            :model="addQosForm"  
            label-width="150px" 
            label-position="left"
            class="fhv-form dialog-form" 
            size="mini"
            :rules="formCheck" 
            ref="addQosForm"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
                <el-form-item label="interface :" prop="iface" v-if="addQosForm.mode === '1'" key="iface">
                    <!-- SR120-A 4口 -->
                    <el-select 
                    v-if="$G_DEVICE_CFG.lanNum === 4 && $G_DEVICE_CFG.area != 'WDC'"
                    v-model="addQosForm.iface" 
                    placeholder="Please select interface"
                    style="width: 100%">
                        <el-option label="LAN1" value="LAN1"></el-option>
                        <el-option label="LAN2" value="LAN2"></el-option>
                        <el-option label="LAN3" value="LAN3"></el-option>
                        <el-option label="LAN4" value="LAN4"></el-option>
                        <el-option 
                        :label="'SSID' + (indxe + 1)" 
                        :value="wl.ssid" v-for="(wl,indxe) in wlan" 
                        :disabled="!wl.enable"
                        :key="wl.ssidIndex"></el-option>
                    </el-select>
                    <el-select 
                    v-else-if="$G_DEVICE_CFG.lanNum === 4 && $G_DEVICE_CFG.area === 'WDC'"
                    v-model="addQosForm.iface" 
                    placeholder="Please select interface"
                    style="width: 100%">
                        <el-option label="LAN1" value="LAN1"></el-option>
                        <el-option label="LAN2" value="LAN2"></el-option>
                        <el-option label="LAN3" value="LAN3"></el-option>
                        <el-option label="LAN4" value="LAN4"></el-option>
                    </el-select>
                    <!-- SR120-A 2口 -->
                    <el-select 
                    v-else-if="$G_DEVICE_CFG.lanNum === 2 && $G_DEVICE_CFG.area != 'WDC'"
                    v-model="addQosForm.iface" 
                    placeholder="Please select interface"
                    style="width: 100%">
                        <el-option label="LAN1" value="LAN3"></el-option>
                        <el-option label="LAN2" value="LAN4"></el-option>
                        <el-option 
                        :label="'SSID' + (indxe + 1)" 
                        :value="wl.ssid" v-for="(wl,indxe) in wlan" 
                        :disabled="!wl.enable"
                        :key="wl.ssidIndex"></el-option>
                    </el-select>
                    <el-select 
                    v-else-if="$G_DEVICE_CFG.lanNum === 2 && $G_DEVICE_CFG.area === 'WDC'"
                    v-model="addQosForm.iface" 
                    placeholder="Please select interface"
                    style="width: 100%">
                        <el-option label="LAN1" value="LAN3"></el-option>
                        <el-option label="LAN2" value="LAN4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="MAC Address :" prop="mac" v-if="addQosForm.mode === '4'" key="mac">
                    <el-input v-model="addQosForm.mac"></el-input>
                </el-form-item>
                <el-form-item label="Start IP Address :" prop="ipStart" v-if="addQosForm.mode === '3'" key="ipStart">
                    <el-input v-model="addQosForm.ipStart"></el-input>
                </el-form-item>
                <el-form-item label="End IP Address :" prop="ipEnd" v-if="addQosForm.mode === '3'" key="ipEnd">
                    <el-input v-model="addQosForm.ipEnd"></el-input>
                </el-form-item>
                <el-form-item label="rate :" prop="rate">
                    <el-input v-model.number="addQosForm.rate"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" :disabled="$G_DEVICE_CFG.isReadOnly">Cancel</el-button>
                <el-button type="primary" @click="confirm" :disabled="$G_DEVICE_CFG.isReadOnly">Confirm</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading:false,
            dialogFormVisible:false,
            qosEnable: false,
            up:{
                mode:'0',
                iface:[],
                ip:[],
                mac:[]
            },
            down:{
                mode:'0',
                iface:[],
                ip:[],
                mac:[]
            },
            wlan:[],
            addQosForm:{
                mode:'0',
                direction:'',
                mac:'',
                iface:'',
                ipStart:'',
                ipEnd:'',
                rate:1
            },
            formCheck:{
                iface:[
                    { required: true, message: 'Please select interface.', trigger: 'blur' }
                ],
                mac:[
                    { required: true, message: 'mac cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isMACAddress(value))
                                callback(new Error('mac error! e.g. 00:ca:cb:ff:dd:22'));
                            else
                                callback()
                        },
                        trigger: 'blur'
                    }
                ],
                ipStart:[
                    { required: true, message: 'start ip cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isIP(value,4))
                                callback(new Error('start ip error! e.g. 192.168.1.1'));
                            else
                                callback()
                        },
                        trigger: 'blur'
                    }
                ],
                ipEnd:[
                    { required: true, message: 'end ip cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isIP(value,4))
                                callback(new Error('end ip error! e.g. 192.168.1.1'));
                            else
                                callback()
                        },
                        trigger: 'blur'
                    }
                ],
                rate:[
                    { required: true, message: 'rate cannot be empty.', trigger: 'blur' },
                    { type:'number', min: 1, max: 2048,message: 'rate range is [1-2048].The maximum QoS rate is 1G.', trigger: 'blur' },
                ]
            }
        }
    },
    beforeMount(){
        this.getData()
    },
    methods: {
        // 获取数据
        getData() {
            this.loading = true
            axios
            .post("/boafrm/fhQos",{CmdType:"GET_QOS"})
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    let upData = response.data.qos.up
                    let downData = response.data.qos.down
                    if(this.$G_DEVICE_CFG.lanNum === 2)
                    {
                        upData.iface.map(e => {
                            e.iface = (e.iface === 'LAN3') ? 'LAN1' : e.iface
                            e.iface = (e.iface === 'LAN4') ? 'LAN2' : e.iface
                        })
                        downData.iface.map(e => {
                            e.iface = (e.iface === 'LAN3') ? 'LAN1' : e.iface
                            e.iface = (e.iface === 'LAN4') ? 'LAN2' : e.iface
                        })
                    }
                    
                    this.qosEnable = response.data.qos.qospEnable
                    
                    this.up = upData
                    this.down = downData
                    this.wlan = response.data.qos.wlan
                }
                else
                    this.$message.error('GET data failed!')
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('GET data failed! Network connection error!')
            })
            
        },
        // 删除 qos 规则
        delData(delIndex,direction){
            this.loading = true

            const indxeToName = {
                '1':'iface',
                '3':'ip',
                '4':'mac'
            }
            let qosCarList = {}

            let potData = {
                CmdType:"SET_QOS_CAR",
                qosDirection:direction,
                index:delIndex + 1,
                action:'DEL'
            }

            if(direction == 'up')
            {
                potData.qosMode = this.up.mode
                qosCarList = this.up[indxeToName[this.up.mode]]
            }
            else
            {
                potData.qosMode = this.down.mode
                qosCarList = this.down[indxeToName[this.down.mode]]
            }

            axios
            .post("/boafrm/fhQos",potData)
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.$message.success('Delete success!')

                    // 删除成功 删除页面UI数据
                    if(qosCarList)
                        qosCarList.splice(delIndex,1)
                }
                else
                    this.$message.error('Delete data failed!')
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('Delete data failed! Network connection error!')
            }) 

        },
        // qos 模式切换
        selectQosMode(direction){
            this.loading = true
            let potData = {
                CmdType:"SET_QOS_CAR",
                qosDirection:direction,
                action:'CHANGE_MODE'
            }

            if(direction == 'up')
                potData.qosMode = this.up.mode
            else
                potData.qosMode = this.down.mode

            axios
            .post("/boafrm/fhQos",potData)
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.$message.success('Change QoS mode success!')
                }
                else
                    this.$message.error('Change QoS mode failed!')
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('Change QoS mode failed! Network connection error!')
            }) 
        },
        // 增加QoS 规则
        addQosData(){
            this.loading = true
            let potData = {
                CmdType:"SET_QOS_CAR",
                qosDirection:this.addQosForm.direction,
                qosMode:this.addQosForm.mode,
                mac:this.addQosForm.mac,
                car_iface:this.addQosForm.iface,
                ipStart:this.addQosForm.ipStart,
                ipEnd:this.addQosForm.ipEnd,
                rate:this.addQosForm.rate,
                action:'ADD'
            }

            axios
            .post("/boafrm/fhQos",potData)
            .then((response)=>{
                if(response.data.ret === 0)
                {
                    this.$message.success('Add QoS Rules Success!')
                    this.getData()
                }
                else
                    this.$message.error(`Add QoS Rules Failed!Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('Add QoS Rules Failed! Network connection error!')
            }) 
        },
        setQosEnable(){
            this.loading = true

            axios
            .post("/boafrm/fhQos",{
                CmdType:'SET_QOS_ENABLE',
                qosEnable:this.qosEnable
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.$message.success('Configuration is success!')
                }
                else
                   this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('Add QoS Rules Failed! Network connection error!')
            }) 
        },
        // 格式化IP地址段显示
        ipFormatter(row, column){
            return row.ipStart + '-' + row.ipEnd
        },
        // 展示规则输入表单
        showAddQos(direction){
            this.addQosForm.direction = direction
            if(direction == 'up')
                this.addQosForm.mode = this.up.mode
            else
                this.addQosForm.mode = this.down.mode
            
            if(this.addQosForm.mode === '0' || this.addQosForm.mode === '')
                return
            
            // 重置添加表单数据
            this.addQosForm.mac = ''
            this.addQosForm.iface = ''
            this.addQosForm.ipStart = ''
            this.addQosForm.ipEnd = ''
            this.addQosForm.rate = 1
            this.dialogFormVisible = true
        },
        confirm(){
            this.$refs['addQosForm'].validate((valid) => {
                if (valid) {
                    this.dialogFormVisible = false
                    this.addQosData()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
}
</script>

<style scoped>
.dialog-form{
    margin-left: 15%
}
@media (max-width: 768px) {
    .dialog-form{
        margin-left: 0;
    }
}
</style>